export default {

	state: {
		physicians: [],
		loaded: false,
    },

	actions: {
		fetchPhysicians({commit, state}) {
			if (state.physicians === undefined || state.physicians.length == 0){
				axios.get('/api/physicians/list').then(({ data }) => {
					commit('setPhysicians', data);
				});
			}
		},

		addNewPhysician({commit}, data) {
			commit('setNewPhysician', data);
		},

		removePhysicians({commit}, data) {
			commit('splicePhysicians', data);
		},

		updatePhysician({commit}, data) {
			commit('setPhysicianData', data)
		},	
	},

    mutations: {
		setPhysicians(state, physicians) {
			state.physicians = physicians;
			state.loaded = true;
			this.state.config.loaded.physicians = true;
		},

		setNewPhysician(state, data) {
			state.physicians.push(data);
			this._vm.$root.$emit('physician_added', true);
			this._vm.$root.$emit('providers_changed', true);
		},

		setPhysicianData(state, data) {
			Object.assign(state.physicians[state.physicians.findIndex(physician => physician.id === data.id)], data);
			this._vm.$root.$emit('providers_changed', true);
		},

		splicePhysicians(state, data) {
			data.forEach(id => {				
				state.physicians.splice(state.physicians.findIndex(physician => physician.id === id), 1);
			});
			this._vm.$root.$emit('providers_changed', true);
		},

    },

    getters: {
		allPhysicianIds(state, getters) {
			return state.physicians
				.map(physician => ({
					//code: 'physician_' + physician.id,
					//id : physician.id,
					display_name : physician.display_name,
					morphable_id : physician.id,
					type : 'Physician',
					morphable_type : 'App\\Physician',
				}))
				.sort((a, b) => a.display_name.localeCompare(b.display_name));
		},

		mappablePhysicianIds(state, getters) {
			return state.physicians
				.filter(physician => physician.location_primary && physician.location_primary.latitude && physician.location_primary.longitude)
				.map(physician => ({
					//code: 'physician_' + physician.id,
					//id : physician.id,
					display_name : physician.display_name,
					type : 'Physician',
					morphable_id : physician.id,
					morphable_type : 'App\\Physician',
					location_id : physician.location_primary.id,
					short_address : physician.location_primary.short_address,
				}))
				.sort((a, b) => a.display_name.localeCompare(b.display_name));
		},

		nearbyPhysicianIds: (state) => (params) => {
			//3rd decimal is about 110m of precision
        	//https://gis.stackexchange.com/questions/8650/measuring-accuracy-of-latitude-and-longitude
			return state.physicians
				.filter(physician => physician.locations
					.some(location => 
						location.latitude  <= (params.latitude + .002) && 
						location.latitude  >= (params.latitude - .002) && 
						location.longitude <= (params.longitude + .002) && 
						location.longitude >= (params.longitude - .002)
					)
				)
				.map(physician => ({
					//code: 'physician_' + physician.id,
					//id : physician.id,
					display_name : physician.display_name,
					type : 'Physician',
					morphable_id : physician.id,
					morphable_type : 'App\\Physician',
					location_id : physician.locations.filter(location => 
						location.latitude  <= (params.latitude + .002) && 
						location.latitude  >= (params.latitude - .002) && 
						location.longitude <= (params.longitude + .002) && 
						location.longitude >= (params.longitude - .002))[0].id,
					short_address : physician.locations.filter(location => 
						location.latitude  <= (params.latitude + .002) && 
						location.latitude  >= (params.latitude - .002) && 
						location.longitude <= (params.longitude + .002) && 
						location.longitude >= (params.longitude - .002))[0].short_address,
				}));
		}
    }
};